// roomBookingTypes.ts
// Reducer folder structure in comments
//|--redux
//|   |--roomBooking
//|   |   |--roomBookingActions.ts
//|   |   |--roomBookingReducer.ts
//|   |   |--roomBookingSaga.ts
//|   |   |--roomBookingTypes.ts

export const roomBookingActionTypes = {
  API_RESPONSE_SUCCESS: 'API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: 'API_RESPONSE_ERROR',

  FETCH_ROOM_OPTIONS: 'FETCH_ROOM_OPTIONS',
  FETCH_BOOKING_DETAILS: 'FETCH_BOOKING_DETAILS',
  SET_SELECTED_ROOM_NUMBER: 'SET_SELECTED_ROOM_NUMBER',
  SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
  CLEAR_ERROR_MESSAGE: 'CLEAR_ERROR_MESSAGE',
};

export interface PaymentDetail {
  label: string;
  amount: number;
}

export interface BalancePaymentDetails {
  totalAccrued: number;
  totalPaid: number;
  balance: number;
  details: PaymentDetail[];
}

// State structure for roomBooking reducer
export interface roomBookingState {
  roomOptions: string[];
  selectedRoomNumber: string;
  guestName: string;
  activeBookingId: string | null;
  balancePaymentDetails: BalancePaymentDetails;
  isRoomListLoading: boolean;
  isBookingDetailsLoading: boolean;
  errorMessage: string;
  infoMessage: string;
}